export enum RemoteStatus {
	None,
	InProgress,
	Done,
	Error,
}

export type RemoteError = {
	errorCode: string;
	category: string;
	key: string;
	defaultMessage: string;
	spanId: string;
	traceId: string;
};

export type RemoteData<T> = {
	data?: T;
	status: RemoteStatus;
	error?: RemoteError;
};
